var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid grid-cols-2", class: _vm.gapSize }, [
    _c("img", {
      staticClass: "col-span-2 lazyload object-cover w-full",
      class: _vm.image1Height,
      attrs: { "data-src": _vm.images[0].url }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "lazyload object-cover w-full",
      class: _vm.image2Height,
      attrs: { "data-src": _vm.images[1].url }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "lazyload object-cover w-full",
      class: _vm.image3Height,
      attrs: { "data-src": _vm.images[2].url }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }